<template>
	<DividerAutoDirection>{{ $t('base-stations-edit.fields.rtcm1033.divider') }}</DividerAutoDirection>
	<Row>
		<Col :span="24" :md="{ span: 16, offset: 8 }" :lg="{ span: 20, offset: 4 }" :xl="{ span: 13, offset: 4 }">
			<Descriptions
				:column="1"
				:colon="false"
				bordered
				size="small"
				:labelStyle="{ backgroundColor: 'white' }"
				:contentStyle="{ backgroundColor: 'white' }"
			>
				<DescriptionsItem
					v-for="field in fields"
					:key="field"
					:label="$t('base-stations-edit.fields.rtcm1033.' + field)"
				>
					{{ displayValue(field) }}
				</DescriptionsItem>
			</Descriptions>
		</Col>
	</Row>
</template>

<script>
import { Row, Col, Descriptions, DescriptionsItem } from 'ant-design-vue';

import DividerAutoDirection from '@/components/common/DividerAutoDirection.vue';

const fields = [
	'station_id',
	'antenna_descriptor',
	'antenna_setup_id',
	'antenna_serial_number',
	'receiver_model',
	'receiver_firmware_version',
	'receiver_serial_number',
];

export default {
	components: { Row, Col, Descriptions, DescriptionsItem, DividerAutoDirection },
	props: ['baseStationDetails'],
	setup(props) {
		const displayValue = field => {
			const value = props.baseStationDetails?.rtcm1033Info?.[field];
			return value == null || value === '' ? '—' : value;
		};
		return { fields, displayValue };
	},
};
</script>
